var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"navbar"},[_vm._v("\n      题目类型：\n      "),_vm._l((_vm.cptMenuItemList),function(item,index){return _c('navbar-item',{key:index,attrs:{"item":item,"activeItem":_vm.activeItem},on:{"onClick":_vm.nowNavbarItem}})})],2),_vm._v(" "),_c('div',{staticClass:"code-bd"},_vm._l((_vm.questions),function(item,index){return _c('code-cell',{key:index,attrs:{"paperId":_vm.paperId,"item":item}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-top-img"},[_c('div',{staticClass:"title"},[_vm._v("在线编程专项练习")]),_vm._v(" "),_c('div',[_vm._v("术业有专攻，亦或八项皆全能")])])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/practice/code/index.vue?vue&type=template&id=6253f648&scoped=true
// module id = null
// module chunks = 